// extracted by mini-css-extract-plugin
export default {"qtyField":"deliveryOrderItemsTable_qtyField__A3Suq"};